module.exports = __webpack_public_path__ + "static/img/027_TO8_1520.96278ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/027_TO8_1520.jpg
// module id = ln1z
// module chunks = 0